import React, { HTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export interface FormBlockProps extends HTMLAttributes<HTMLDivElement> {
  header?: ReactNode;
  subHeader?: ReactNode;
}

export const formBlockClassName = 'space-y-4 bg-white px-4 py-5 rounded-lg border border-neutral-200 font-open-sans';

export const FormBlock: React.FC<FormBlockProps> = ({ header, subHeader, className, children, ...props }) => {
  return (
    <div className={twMerge(formBlockClassName, className)} {...props}>
      {header && <h2 className="text-primary font-open-sans mb-2 text-xl font-semibold leading-6">{header}</h2>}
      {subHeader && (
        <p className="font-open-sans text-section-header-slate mb-4 text-sm font-medium leading-6">{subHeader}</p>
      )}
      {children}
    </div>
  );
};
